import { render, staticRenderFns } from "./LevelTypeSelectionComponent.vue?vue&type=template&id=c5512190&"
import script from "./LevelTypeSelectionComponent.vue?vue&type=script&lang=js&"
export * from "./LevelTypeSelectionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports